import api from "./axios";

export const getQuotations = (params = {}) => api.get("/quotations", { params });
export const getQuotation = (quotationPublicId) =>
  api.get(`/quotations/${quotationPublicId}`);
export const createQuotation = (data) => api.post("/quotations", data);
export const updateQuotation = (quotationPublicId, data) =>
  api.patch(`/quotations/${quotationPublicId}`, data);
export const submitQuotation = (quotationPublicId) =>
  api.post(`/quotations/${quotationPublicId}/submit`);
export const approveQuotation = (quotationPublicId, reason) =>
  api.post(`/quotations/${quotationPublicId}/approve`, { reason });
export const rejectQuotation = (quotationPublicId, reason) =>
  api.post(`/quotations/${quotationPublicId}/reject`, { reason });
export const cancelQuotation = (quotationPublicId, reason) =>
  api.post(`/quotations/${quotationPublicId}/cancel`, { reason });
export const downloadQuotationPdf = (quotationPublicId) =>
  api.get(`/quotations/${quotationPublicId}/pdf`, { responseType: "blob" });

export const sendQuotationWhatsApp = (quotationPublicId, data) =>
  api.post(`/quotations/${quotationPublicId}/send-whatsapp`, data);
